import printJS from "print-js";

import { is_tauri, tauri_download_and_open } from "./tauri";

function cache_bust_url(url: string): string {
    let cache_buster = Math.random().toString(36).substring(2, 15);
    if (url.includes("?")) {
        return url + "&cache_buster=" + cache_buster;
    }
    return url + "?cache_buster=" + cache_buster;
}

export function print(url: string, orientation: string = "landscape", in_flight_component: any = null) {
    let uri = cache_bust_url(url);

    if (is_tauri()) {
        if (in_flight_component) {
            in_flight_component.in_flight = true;
        }
        tauri_download_and_open(uri).then(() => {
            if (in_flight_component) {
                in_flight_component.in_flight = false;
            }
        });
        return;
    }

    if (navigator.vendor?.includes("Apple")) {
        window.open(uri, "_blank");
        return;
    }

    printJS({
        printable: uri,
        onLoadingStart: function () {
            if (in_flight_component) {
                in_flight_component.in_flight = true;
            }
        },
        onLoadingEnd: function () {
            if (in_flight_component) {
                in_flight_component.in_flight = false;
            }
        },
        style: "@page { size: Letter " + orientation + "; }",
    });
}

export function view(url: string) {
    let uri = cache_bust_url(url);

    window.open(uri, "_blank");
}

export function download(url: string) {
    let uri = cache_bust_url(url);
    uri += "&download=true";

    window.open(uri, "_blank");
}

export function has_view(): boolean {
    return !is_tauri();
}

export function has_download(): boolean {
    return !is_tauri();
}